"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_api_exports = {};
__export(create_api_exports, {
  createApi: () => createApi
});
module.exports = __toCommonJS(create_api_exports);
var import_errors = require("./errors");
const createApi = (url, options) => {
  const { method = "GET", output, auth, headers: initHeaders = {} } = options;
  const outputSchema = output?.["~standard"];
  return async ({
    body,
    authToken,
    params,
    query,
    timeout = options.timeout ?? 12e3,
    headers: customHeaders = {}
  }) => {
    const _url = new URL(url);
    if (auth && !authToken) {
      throw new Error("API requires authentication");
    }
    if (query) {
      Object.entries(query).forEach(([key, value]) => {
        _url.searchParams.append(key, String(value));
      });
    }
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        _url.pathname = _url.pathname.replace(`:${key}`, String(value));
      });
    }
    try {
      const abortController = new AbortController();
      const timer = setTimeout(() => {
        abortController.abort();
      }, timeout);
      const response = await fetch(_url.toString(), {
        method,
        body: body ? JSON.stringify(body) : void 0,
        signal: abortController.signal,
        // @ts-expect-error next headers are not standard
        headers: {
          "Content-Type": "application/json",
          ...auth && authToken ? { Authorization: `Bearer ${authToken}` } : {},
          ...initHeaders,
          ...customHeaders
        }
      });
      clearTimeout(timer);
      if (!response.ok) {
        return {
          error: {
            status: response.status,
            message: response.statusText,
            response
          },
          data: null
        };
      }
      const json = await response.json();
      const result = await outputSchema.validate(json);
      if (result.issues) {
        throw new import_errors.ValidationError(
          "Server response didn't match expected format",
          {
            response,
            issues: result.issues
          }
        );
      }
      return {
        data: result.value,
        error: null
      };
    } catch (e) {
      if (e instanceof import_errors.ValidationError) {
        return {
          data: null,
          error: {
            message: e.message,
            status: e.response?.status ?? 400,
            response: e.response,
            issues: e.issues
          }
        };
      }
      return {
        data: null,
        error: { status: 500, message: "Unexpected error occurred" }
      };
    }
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  createApi
});
